// constants
import * as pages from "./pages";
import { PAGES_KEYS } from "./pagesKeys";
import { PATHS } from "./paths";

// helpers
import { getSideDrawerChildrenRoutes } from "../helpers/routes/getChildrenRoutes/getChildrenRoutes";

// icons
import {
  DashboardOutlined,
  CustomerServiceOutlined,
  ProfileOutlined,
  PhoneOutlined,
  CarOutlined,
  MergeCellsOutlined,
  UserOutlined,
  PartitionOutlined,
  HistoryOutlined,
  NotificationOutlined,
  SisternodeOutlined,
  RetweetOutlined,
  StopOutlined,
  RollbackOutlined,
  EyeOutlined,
  DollarOutlined,
  FileDoneOutlined,
  GatewayOutlined,
  WechatOutlined,
  ToolOutlined,
  GroupOutlined,
  CheckOutlined,
  SoundOutlined,
  SafetyOutlined,
  DatabaseOutlined,
  MonitorOutlined,
  PicCenterOutlined,
  MobileOutlined,
  DownCircleOutlined,
  ControlOutlined,
  StarOutlined,
  HeatMapOutlined,
  DollarCircleOutlined,
  ContainerOutlined,
  SolutionOutlined,
  CodeSandboxOutlined,
  InboxOutlined,
  ScheduleOutlined,
  SwapOutlined,
  MinusCircleOutlined,
  CheckSquareOutlined,
  IdcardOutlined,
  ShoppingOutlined,
  RiseOutlined,
  DiffOutlined,
  OpenAIOutlined,
  SettingOutlined,
  AppstoreAddOutlined,
  FileSearchOutlined,
  MoneyCollectOutlined,
  UsergroupDeleteOutlined,
  LockOutlined,
  AppstoreOutlined,
  UsergroupAddOutlined,
  QuestionCircleOutlined,
  FieldTimeOutlined,
  ClusterOutlined,
  BulbOutlined,
  MergeOutlined,
  DeploymentUnitOutlined,
  QuestionOutlined,
  CalendarOutlined,
  DisconnectOutlined,
  BranchesOutlined
} from "@ant-design/icons";

// sideDrawer children routes
export const SIDE_DRAWER_CHILDREN_ROUTES = {
  [PAGES_KEYS.mySales]: [
    {
      key: PAGES_KEYS.salesUserDashboard,
      path: PATHS.salesDashboard,
      page: pages.SalesUserDashboard,
      icon: <CustomerServiceOutlined />,
      label: "Sales Dashboard",
    },
    {
      key: PAGES_KEYS.telesalesRunsheet,
      path: PATHS.telesalesRunsheet,
      page: pages.TelesalesRunsheet,
      icon: <PhoneOutlined />,
      label: "Telesales Runsheet",
    },
    {
      key: PAGES_KEYS.trackingSalesVisits,
      path: PATHS.salesVisits,
      page: pages.TrackingSalesVisits,
      icon: <SolutionOutlined />,
      label: "Sales Visits",
    },
    {
      key: PAGES_KEYS.salesTracking,
      path: PATHS.salesTracking,
      page: pages.SalesTracking,
      icon: <HeatMapOutlined />,
      label: "Sales Tracking",
    },
    {
      key: PAGES_KEYS.salesAgents,
      path: PATHS.salesAgents,
      page: pages.SalesAgentsPage,
      icon: <IdcardOutlined />,
      label: "Sales Agents",
    },
  ],

  [PAGES_KEYS.vendor]: [
    {
      key: PAGES_KEYS.vendorSupport,
      path: PATHS.vendorSupportPricing,
      page: pages.VendorSupport,
      icon: <DollarOutlined />,
      label: "Vendor Support Pricing",
    },
    {
      key: PAGES_KEYS.repricingOrders,
      path: PATHS.repriceNeededOrders,
      page: pages.RepricingOrders,
      icon: <RetweetOutlined />,
      label: "Sales Need Support",
    },
    {
      key: PAGES_KEYS.acceptedOrdersDashboard,
      path: PATHS.acceptedOrders,
      page: pages.AcceptedOrdersDashboard,
      icon: <FileDoneOutlined />,
      label: "Accepted Orders",
    },
  ],

  [PAGES_KEYS.tower]: [
    {
      key: PAGES_KEYS.opsNeedSupport,
      path: PATHS.opsNeedSupport,
      page: pages.NeedSupportDashboard,
      icon: <GatewayOutlined />,
      label: "Ops Need Support",
    },
    {
      key: PAGES_KEYS.mechanicNeedSupport,
      path: PATHS.mechanicNeedSupport,
      page: pages.MechanicNeedSupport,
      icon: <RollbackOutlined />,
      label: "Mechanic Need Support",
    },
    {
      key: PAGES_KEYS.towerHistory,
      path: PATHS.towerHistory,
      page: pages.TowerHistory,
      icon: <HistoryOutlined />,
      label: "Tower History",
    },
  ],

  [PAGES_KEYS.operations]: [
    {
      key: PAGES_KEYS.courierAssignmentAcceptOrders,
      path: PATHS.courierAssignmentAcceptOrders,
      page: pages.CourierAssignmentAcceptOrders,
      icon: <CarOutlined />,
      label: "Courier Assignment Dashboard",
    },
    {
      key: PAGES_KEYS.courierAssignmentFulfilledOrders,
      path: PATHS.courierAssignment,
      page: pages.CourierAssignment,
      icon: <CheckSquareOutlined />,
      label: "Fulfilled Orders",
    },
    {
      key: PAGES_KEYS.reallocationGroups,
      path: PATHS.reallocationGroups,
      page: pages.ReallocationGroups,
      icon: <GroupOutlined />,
      label: "Reallocation Groups",
    },
    {
      key: PAGES_KEYS.availableCouriers,
      path: PATHS.availableCouriers,
      page: pages.AvailableCouriers,
      icon: <IdcardOutlined />,
      label: "Available Couriers",
    },
    {
      key: PAGES_KEYS.polygons,
      path: PATHS.polygons,
      page: pages.Polygons,
      icon: <AppstoreOutlined />,
      label: "Polygons",
    },
    {
      key: PAGES_KEYS.polygonGroups,
      path: PATHS.polygonGroups,
      page: pages.PolygonGroups,
      icon: <AppstoreOutlined />,
      label: "Polygon Groups",
    },
    {
      key: PAGES_KEYS.vehicles,
      path: PATHS.vehicles,
      page: pages.Vehicles,
      icon: <CarOutlined />,
      label: "Vehicles",
    },
    {
      key: PAGES_KEYS.courierAssignmentTransferOrder,
      path: PATHS.courierAssignmentTransferOrders,
      page: pages.CourierAssignmentTransferOrder,
      icon: <SwapOutlined />,
      label: "Transfer Orders Courier Assignment",
    },
    {
      key: PAGES_KEYS.pendingCourierDeficits,
      path: PATHS.pendingCourierDeficits,
      page: pages.PendingCourierDeficits,
      icon: <MinusCircleOutlined />,
      label: "Pending Courier Deficits",
    },
    {
      key: PAGES_KEYS.courierTasks,
      path: PATHS.courierTasks,
      page: pages.CourierTasks,
      icon: <CheckOutlined />,
      label: "Courier Tasks",
    },
    {
      key: PAGES_KEYS.courierSupplierHub,
      path: PATHS.courierSupplierHub,
      page: pages.CourierSupplierHub,
      icon: <PicCenterOutlined />,
      label: "Courier Supplier Hub",
    },
    {
      key: PAGES_KEYS.couriersDashboard,
      path: PATHS.couriers,
      page: pages.Couriers,
      icon: <IdcardOutlined />,
      label: "Couriers",
    },
    {
      key: PAGES_KEYS.returnsDashboard,
      path: PATHS.returnsDashboard,
      page: pages.ReturnedItemsDashboard,
      icon: <RetweetOutlined />,
      label: "Returns Dashboard",
    },
    {
      key: PAGES_KEYS.failedReturnsDashboard,
      path: PATHS.failedReturnsDashboard,
      page: pages.FailedReturnOrdersDashboard,
      icon: <StopOutlined />,
      label: "Failed Returns Dashboard",
    },
    {
      key: PAGES_KEYS.nonDeliveryDates,
      path: PATHS.nonDeliveryDates,
      page: pages.NonDeliveryDates,
      icon: <StopOutlined />,
      label: "Non-Delivery",
    },
    {
      key: PAGES_KEYS.expressHours,
      path: PATHS.expressHours,
      page: pages.ExpressHours,
      icon: <FieldTimeOutlined />,
      label: "Express Hours",
    },
     {
      key: PAGES_KEYS.warehouseZones,
      path: PATHS.warehouseZones,
      page: pages.WarehouseZones,
      icon: <BranchesOutlined />,
      label: "Warehouse Zones",
    },
  ],

  [PAGES_KEYS.picking]: [
    {
      key: PAGES_KEYS.pickers,
      path: PATHS.pickers,
      page: pages.Pickers,
      icon: <IdcardOutlined />,
      label: "Pickers",
    },
    {
      key: PAGES_KEYS.runsheetsDashboard,
      path: PATHS.runsheetsDashboard,
      page: pages.RunsheetsDashboard,
      icon: <CalendarOutlined />,
      label: "Runsheets Dashboard",
    },
    {
      key: PAGES_KEYS.pickerTab,
      path: PATHS.pickerTab,
      page: pages.PickerTab,
      icon: <InboxOutlined />,
      label: "Picker Tab",
    },
  ],

  [PAGES_KEYS.quality]: [
    {
      key: PAGES_KEYS.qualityReviewOrders,
      path: PATHS.qualityReviewOrders,
      page: pages.ReviewOrders,
      icon: <StarOutlined />,
      label: "Review Orders",
    },
    {
      key: PAGES_KEYS.qualityTickets,
      path: PATHS.qualityTickets,
      page: pages.Tickets,
      icon: <ScheduleOutlined />,
      label: "Tickets",
    },
    {
      key: PAGES_KEYS.qualityReturnTickets,
      path: PATHS.qualityReturnTickets,
      page: pages.ReturnTickets,
      icon: <RollbackOutlined />,
      label: "Return Orders",
    },
    {
      key: PAGES_KEYS.qualityReturns,
      path: PATHS.qualityReturns,
      page: pages.Returns,
      icon: <HistoryOutlined />,
      label: "Returns",
    },
    {
      key: PAGES_KEYS.qualityNeedInvestigation,
      path: PATHS.qualityNeedInvestigation,
      page: pages.NeedInvestigation,
      icon: <MonitorOutlined />,
      label: "Need Investigation",
    },
    {
      key: PAGES_KEYS.qualityVoiceComplaints,
      path: PATHS.qualityVoiceComplaints,
      page: pages.VoiceComplaints,
      icon: <SoundOutlined />,
      label: "Voice Complaints",
    },
    {
      key: PAGES_KEYS.reasons,
      path: PATHS.reasons,
      page: pages.Reasons,
      icon: <QuestionCircleOutlined />,
      label: "Reasons",
    },
  ],

  [PAGES_KEYS.inventory]: [
    {
      key: PAGES_KEYS.inventoryDashboard,
      path: PATHS.inventoryDashboard,
      page: pages.InventoryDashboard,
      icon: <MergeCellsOutlined />,
      label: "Inventory Dashboard",
    },
    {
      key: PAGES_KEYS.consignment,
      path: PATHS.consignment,
      page: pages.Consignment,
      icon: <ContainerOutlined />,
      label: "Consignment",
    },
    {
      key: PAGES_KEYS.consignmentCustomerReturns,
      path: PATHS.consignmentCustomerReturns,
      page: pages.ConsignmentCustomerReturns,
      icon: <ContainerOutlined />,
      label: "Customer Returns",
    },
    {
      key: PAGES_KEYS.consignmentReturns,
      path: PATHS.consignmentReturns,
      page: pages.ConsignmentReturns,
      icon: <ContainerOutlined />,
      label: "Consignment Returns",
    },
    {
      key: PAGES_KEYS.inventorySaleOrders,
      path: PATHS.saleOrdersDashboard,
      page: pages.SalesOrdersDashboard,
      icon: <MoneyCollectOutlined />,
      label: "Sale Orders",
    },
    {
      key: PAGES_KEYS.inventoryReturnOrders,
      path: PATHS.returnOrdersDashboard,
      page: pages.ReturnOrdersDashboard,
      icon: <RollbackOutlined />,
      label: "Return Orders",
    },
    {
      key: PAGES_KEYS.inventoryPurchaseOrders,
      path: PATHS.purchaseOrdersDashboard,
      page: pages.PurchaseOrders,
      icon: <ShoppingOutlined />,
      label: "Purchase Orders",
    },
    {
      key: PAGES_KEYS.inventoryTransferOrders,
      path: PATHS.transferOrdersDashboard,
      page: pages.InventoryTransferOrders,
      icon: <RetweetOutlined />,
      label: "Transfer Orders",
    },
    {
      key: PAGES_KEYS.skusMissingCbm,
      path: PATHS.skusMissingCbm,
      page: pages.SkusMissingCbm,
      icon: <PartitionOutlined />,
      label: "Skus Missing CBM",
    },
  ],

  [PAGES_KEYS.commercial]: [
    {
      key: PAGES_KEYS.commercialInventoryDashboard,
      path: PATHS.commercialInventoryDashboard,
      page: pages.CommercialInventoryDashboard,
      icon: <MergeCellsOutlined />,
      label: "Inventory Dashboard",
    },
    {
      key: PAGES_KEYS.repricingRequests,
      path: PATHS.repricingRequests,
      page: pages.RepricingRequests,
      icon: <DollarOutlined />,
      label: "Repricing Requests",
    },
    {
      key: PAGES_KEYS.repricingInventorySkus,
      path: PATHS.repricingInventorySkus,
      page: pages.RepricingInventorySkus,
      icon: <DollarOutlined />,
      label: "Repricing Inventory Skus",
    },
    {
      key: PAGES_KEYS.subCategoriesMargin,
      path: PATHS.subCategoriesMargin,
      page: pages.SubCategoriesMargin,
      icon: <DiffOutlined />,
      label: "Sub-Categories Margin",
    },
    {
      key: PAGES_KEYS.requestedProducts,
      path: PATHS.requestedProducts,
      page: pages.RequestedProducts,
      icon: <InboxOutlined />,
      label: "Requested Products",
    },
    {
      key: PAGES_KEYS.requestsDetails,
      path: PATHS.requestsDetails,
      page: pages.RequestsDetails,
      icon: <InboxOutlined />,
      label: "Requests Details",
    },
    {
      key: PAGES_KEYS.commercialMapping,
      path: PATHS.commercialMapping,
      page: pages.CommercialMapping,
      icon: <DiffOutlined />,
      label: "Commercial Mapping",
    },
    {
      key: PAGES_KEYS.mtorAiMapping,
      path: PATHS.mtorAiMapping,
      page: pages.MtorAiMapping,
      icon: <OpenAIOutlined />,
      label: "Mtor AI Mapping",
    },
    {
      key: PAGES_KEYS.intersectionMatrix,
      path: PATHS.intersectionMatrix,
      page: pages.IntersectionMatrix,
      icon: <DeploymentUnitOutlined />,
      label: "Intersection Matrix",
    },
    {
      key: PAGES_KEYS.intersectionIds,
      path: PATHS.intersectionIds,
      page: pages.IntersectionIds,
      icon: <MergeOutlined />,
      label: "Intersection IDs",
    },
    {
      key: PAGES_KEYS.skusTargets,
      path: PATHS.skusTargets,
      page: pages.SkusTargets,
      icon: <RiseOutlined />,
      label: "SKUs Targets",
    },
  ],
  [PAGES_KEYS.instaMart]: [
    {
      key: PAGES_KEYS.instaMartUsers,
      path: PATHS.instaMartUsers,
      page: pages.InstaMartUsers,
      icon: <UserOutlined />,
      label: "InstaParts Users",
    },
    {
      key: PAGES_KEYS.instaPartsPolygons,
      path: PATHS.instaPartsPolygons,
      page: pages.InstaPartsPolygons,
      icon: <AppstoreOutlined />,
      label: "Polygons",
    },
    {
      key: PAGES_KEYS.instaPartsReturnOrders,
      path: PATHS.instaPartsReturnOrders,
      page: pages.InstaPartsReturnOrders,
      icon: <RollbackOutlined />,
      label: "Return Orders",
    },
    {
      key: PAGES_KEYS.instaPartsStockReturns,
      path: PATHS.instaPartsStockReturns,
      page: pages.InstaPartsStockReturns,
      icon: <SwapOutlined />,
      label: "Stock Returns",
    },
    {
      key: PAGES_KEYS.instaMartPos,
      path: PATHS.instaMartPos,
      page: pages.Pos,
      icon: <ShoppingOutlined />,
      label: "Purchase Orders",
    },
    {
      key: PAGES_KEYS.instaMartSos,
      path: PATHS.instaMartSos,
      page: pages.Sos,
      icon: <MoneyCollectOutlined />,
      label: "Sale Orders",
    },
  ],

  [PAGES_KEYS.systemData]: [
    {
      key: PAGES_KEYS.mechanicsDashboard,
      path: PATHS.mechanicsDashboard,
      page: pages.MechanicsDashboard,
      icon: <UserOutlined />,
      label: "Mechanics Dashboard",
    },
    {
      key: PAGES_KEYS.MECHANIC_CATEGORY,
      path: PATHS.MECHANIC_CATEGORY,
      page: pages.MechanicCategory,
      icon: <AppstoreOutlined />,
      label: "Mechanic Category",
    },
    {
      key: PAGES_KEYS.MECHANIC_SEGMENT,
      path: PATHS.MECHANIC_SEGMENT,
      page: pages.MechanicSegment,
      icon: <GatewayOutlined />,
      label: "Mechanic Segment",
    },
    {
      key: PAGES_KEYS.MECHANIC_SIZE,
      path: PATHS.MECHANIC_SIZE,
      page: pages.MechanicSize,
      icon: <GatewayOutlined />,
      label: "Mechanic Size",
    },
    {
      key: PAGES_KEYS.suppliersDashboard,
      path: PATHS.suppliersDashboard,
      page: pages.SuppliersDashboard,
      icon: <UserOutlined />,
      label: "Suppliers Dashboard",
    },
    {
      key: PAGES_KEYS.carsDashboard,
      path: PATHS.carsDashboard,
      page: pages.CarsDashboard,
      icon: <CarOutlined />,
      label: "Cars Dashboard",
    },
    {
      key: PAGES_KEYS.skusDashboard,
      path: PATHS.skusDashboard,
      page: pages.SkusDashboard,
      icon: <PartitionOutlined />,
      label: "SKUs Dashboard",
    },
    {
      key: PAGES_KEYS.skusPendingVerify,
      path: PATHS.skusPendingVerify,
      page: pages.SkusPending,
      icon: <PartitionOutlined />,
      label: "SKUs Pending",
    },
    {
      key: PAGES_KEYS.skusReturnPendingVerify,
      path: PATHS.skusReturnPendingVerify,
      page: pages.SkusReturnPending,
      icon: <PartitionOutlined />,
      label: "SKUs Return Pending",
    },
    // {
    //   key: PAGES_KEYS.intersectionIds,
    //   path: PATHS.intersectionIds,
    //   page: pages.IntersectionIds,
    //   icon: <MergeOutlined />,
    //   label: "Intersection IDs",
    // },
    {
      key: PAGES_KEYS.brandFamiliesDashboard,
      path: PATHS.brandFamiliesDashboard,
      page: pages.BrandFamiliesDashboard,
      icon: <SisternodeOutlined />,
      label: "Brand Families Dashboard",
    },
    {
      key: PAGES_KEYS.supplierPendingSkus,
      path: PATHS.supplierPendingSkus,
      page: pages.SupplierPendingSkus,
      icon: <ContainerOutlined />,
      label: "Supplier Pending Skus",
    },
    {
      key: PAGES_KEYS.wrongFitmentTickets,
      path: PATHS.wrongFitmentTickets,
      page: pages.WrongFitmentTickets,
      icon: <DisconnectOutlined />,
      label: "Wrong Fitment Tickets",
    },
    // {
    //   key: PAGES_KEYS.banners,
    //   path: PATHS.banners,
    //   page: pages.Banners,
    //   icon: <MobileOutlined />,
    //   label: "Banners",
    // },
  ],

  [PAGES_KEYS.pricing]: [
    {
      key: PAGES_KEYS.skusEagleEye,
      path: PATHS.skusEagleEye,
      page: pages.SkusEagleEye,
      icon: <EyeOutlined />,
      label: "SKUs Eagle Eye",
    },
    {
      key: PAGES_KEYS.pricingHistoryDashboard,
      path: PATHS.pricingHistoryDashboard,
      page: pages.PricingHistoryDashboard,
      icon: <HistoryOutlined />,
      label: "Pricing History Dashboard",
    },
    {
      key: PAGES_KEYS.supplierSkusPrices,
      path: PATHS.supplierSkusPrices,
      page: pages.SupplierSkusPrices,
      icon: <DollarOutlined />,
      label: "Supplier Skus Prices",
    },
  ],

  [PAGES_KEYS.notificationCenter]: [
    {
      key: PAGES_KEYS.notificationService,
      path: PATHS.notificationService,
      page: pages.NotificationService,
      icon: <SettingOutlined />,
      label: "Notification Service",
    },
    // {
    //   key: PAGES_KEYS.scheduledNotifications,
    //   path: PATHS.scheduledNotifications,
    //   page: pages.ScheduledNotifications,
    //   icon: <ScheduleOutlined />,
    //   label: "Scheduled Notifications",
    // },
    // {
    //   key: PAGES_KEYS.suppliersNotification,
    //   path: PATHS.suppliersNotification,
    //   page: pages.SuppliersNotifications,
    //   icon: <GroupOutlined />,
    //   label: "Suppliers",
    // },
    // {
    //   key: PAGES_KEYS.mechanicsNotification,
    //   path: PATHS.mechanicsNotification,
    //   page: pages.MechanicsNotifications,
    //   icon: <ToolOutlined />,
    //   label: "Mechanics",
    // },
    {
      key: PAGES_KEYS.deepLinks,
      path: PATHS.deepLinks,
      page: pages.DeepLinks,
      icon: <SwapOutlined />,
      label: "deep Links",
    },
  ],

  [PAGES_KEYS.deals]: [
    {
      key: PAGES_KEYS.promotions,
      path: PATHS.promotions,
      page: pages.PromotionEngine,
      icon: <DownCircleOutlined />,
      label: "Promotion",
    },
    {
      key: PAGES_KEYS.bundles,
      path: PATHS.bundles,
      page: pages.Bundle,
      icon: <InboxOutlined />,
      label: "Bundle",
    },
  ],

  [PAGES_KEYS.finance]: [
    {
      key: PAGES_KEYS.taxes,
      path: PATHS.taxes,
      page: pages.Taxes,
      icon: <SafetyOutlined />,
      label: "Taxes",
    },
    {
      key: PAGES_KEYS.instaPartsTaxes,
      path: PATHS.instaPartsTaxes,
      page: pages.InstaPartsTaxes,
      icon: <SafetyOutlined />,
      label: "InstaParts Taxes",
    },
    {
      key: PAGES_KEYS.courierWallet,
      path: PATHS.courierWallet,
      page: pages.CourierWallet,
      icon: <DollarCircleOutlined />,
      label: "Courier Wallet",
    },
    {
      key: PAGES_KEYS.mechanicWallet,
      path: PATHS.mechanicWallet,
      page: pages.MechanicWallet,
      icon: <DollarCircleOutlined />,
      label: "Mechanic Wallet",
    },
    {
      key: PAGES_KEYS.supplierWallet,
      path: PATHS.supplierWallet,
      page: pages.SupplierWallet,
      icon: <DollarCircleOutlined />,
      label: "Supplier Wallet",
    },
    {
      key: PAGES_KEYS.financialHubWallet,
      path: PATHS.supplierHubWallet,
      page: pages.SupplierHubWallet,
      icon: <DollarCircleOutlined />,
      label: "Financial Hub Wallet",
    },
    {
      key: PAGES_KEYS.mechanicCompensations,
      path: PATHS.mechanicCompensations,
      page: pages.MechanicCompensations,
      icon: <DollarCircleOutlined />,
      label: "Mechanic Compensations",
    },
  ],

  [PAGES_KEYS.itManagement]: [
    {
      key: PAGES_KEYS.assets,
      path: PATHS.assets,
      page: pages.Assets,
      icon: <AppstoreAddOutlined />,
      label: "Assets",
    },
    {
      key: PAGES_KEYS.assetLogs,
      path: PATHS.assetLogs,
      page: pages.AssetLogs,
      icon: <FileSearchOutlined />,
      label: "Asset Logs",
    },
    {
      key: PAGES_KEYS.employees,
      path: PATHS.employees,
      page: pages.Employees,
      icon: <UserOutlined />,
      label: "Employees",
    },
  ],

  [PAGES_KEYS.userManagement]: [
    {
      key: PAGES_KEYS.userManagementUsers,
      path: PATHS.users,
      page: pages.UserManagement,
      icon: <UsergroupDeleteOutlined />,
      label: "Users",
    },
    {
      key: PAGES_KEYS.userManagementRoles,
      path: PATHS.roles,
      page: pages.Roles,
      icon: <LockOutlined />,
      label: "Roles",
    },
    {
      key: PAGES_KEYS.mechanicGrouping,
      path: PATHS.mechanicGrouping,
      page: pages.MechanicGrouping,
      icon: <UsergroupAddOutlined />,
      label: "Mechanic Grouping",
    },
  ],
};

// sideDrawer routes
export const SIDE_DRAWER_ROUTES = [
  {
    key: PAGES_KEYS.ordersDashboard,
    path: PATHS.mainDashboard,
    page: pages.OrdersDashboard,
    icon: <DashboardOutlined />,
    label: "Dashboard",
  },
  {
    key: PAGES_KEYS.parentOrders,
    path: PATHS.parentOrders,
    page: pages.ParentOrders,
    icon: <ClusterOutlined />,
    label: "Parent Orders",
  },
  {
    key: PAGES_KEYS.voiceNoteOrders,
    path: PATHS.voiceOrders,
    page: pages.VoiceOrdersDashboard,
    icon: <SoundOutlined />,
    label: "Voice Note Orders",
  },
  {
    key: PAGES_KEYS.voiceAppOrders,
    path: PATHS.voiceAppOrders,
    page: pages.OrdersFromVoiceNotes,
    icon: <MobileOutlined />,
    label: "Voice App Orders",
  },
  {
    key: PAGES_KEYS.appStockOrders,
    path: PATHS.mechanicAppStockOrders,
    page: pages.MechanicAppStockOrders,
    icon: <MobileOutlined />,
    label: "App Stock Orders",
  },
  {
    key: PAGES_KEYS.appAcceptList,
    path: PATHS.mechanicAppPricingOrders,
    page: pages.MechanicAppPricingOrders,
    icon: <MobileOutlined />,
    label: "App Accept List",
  },
  {
    key: PAGES_KEYS.mySales,
    path: PATHS.mySales,
    icon: <UserOutlined />,
    label: "My Sales",
  },
  {
    key: PAGES_KEYS.vendor,
    path: PATHS.vendor,
    icon: <DollarOutlined />,
    label: "Vendor",
  },
  {
    key: PAGES_KEYS.tower,
    path: PATHS.tower,
    icon: <DollarOutlined />,
    label: "Tower",
  },
  {
    key: PAGES_KEYS.operations,
    path: PATHS.operations,
    icon: <ProfileOutlined />,
    label: "Operations",
  },
  {
    key: PAGES_KEYS.picking,
    path: PATHS.picking,
    icon: <InboxOutlined />,
    label: "Picking",
  },
  {
    key: PAGES_KEYS.quality,
    path: PATHS.quality,
    icon: <ControlOutlined />,
    label: "Experience",
  },
  {
    key: PAGES_KEYS.inventory,
    path: PATHS.inventory,
    icon: <DatabaseOutlined />,
    label: "Inventory",
  },
  {
    key: PAGES_KEYS.missingModule,
    path: PATHS.missingTransactions,
    page: pages.MissingTransactions,
    icon: <QuestionOutlined />,
    label: "Missing Transactions",
  },
  {
    key: PAGES_KEYS.commercial,
    path: PATHS.commercial,
    icon: <RiseOutlined />,
    label: "Commercial",
  },
  {
    key: PAGES_KEYS.instaMart,
    path: PATHS.instaMart,
    icon: <BulbOutlined />,
    label: "InstaParts",
  },
  {
    key: PAGES_KEYS.systemData,
    path: PATHS.systemData,
    icon: <DatabaseOutlined />,
    label: "System Data",
  },
  {
    key: PAGES_KEYS.purchaseOrders,
    path: PATHS.purchaseOrders,
    page: pages.PurchaseOrders,
    icon: <ShoppingOutlined />,
    label: "Purchase Orders",
  },
  {
    key: PAGES_KEYS.stockReturns,
    path: PATHS.stockReturns,
    page: pages.StockReturns,
    icon: <SwapOutlined />,
    label: "Stock Returns",
  },

  {
    key: PAGES_KEYS.pricing,
    path: PATHS.pricing,
    icon: <MonitorOutlined />,
    label: "Pricing",
  },
  {
    key: PAGES_KEYS.notificationCenter,
    path: PATHS.notificationCenter,
    icon: <NotificationOutlined />,
    label: "Notification Center",
  },
  {
    key: PAGES_KEYS.deals,
    path: PATHS.deals,
    icon: <CodeSandboxOutlined />,
    label: "Deals",
  },
  {
    key: PAGES_KEYS.finance,
    path: PATHS.finance,
    icon: <DollarCircleOutlined />,
    label: "Finance",
  },
  {
    key: PAGES_KEYS.itManagement,
    path: PATHS.itManagement,
    icon: <ToolOutlined />,
    label: "IT Management",
  },
  {
    key: PAGES_KEYS.chatRooms,
    path: PATHS.chatRooms,
    page: pages.ChatRooms,
    icon: <WechatOutlined />,
    label: "Chat Rooms",
  },
  {
    key: PAGES_KEYS.userManagement,
    path: PATHS.userManagement,
    icon: <UserOutlined />,
    label: "User Management",
  },
  {
    key: PAGES_KEYS.gearbox,
    path: PATHS.gearbox,
    page: pages.Gearbox,
    icon: <SettingOutlined />,
    label: "Gearbox",
  },
];

export const SINGLE_PAGE_ROUTES = [
  {
    key: PAGES_KEYS.editOrder,
    path: PATHS.editOrder(),
    page: pages.EditOrder,
  },
  {
    key: PAGES_KEYS.orderProfile,
    path: PATHS.orderProfile(),
    page: pages.OrderProfile,
  },
  {
    key: PAGES_KEYS.parentOrderProfile,
    path: PATHS.parentOrderProfile(),
    page: pages.ParentOrderProfile,
  },
  {
    key: PAGES_KEYS.pricingOrder,
    path: PATHS.pricingOrder(),
    page: pages.OrderPricingPage,
  },
  {
    key: PAGES_KEYS.opFormOrder,
    path: PATHS.opFormOrder(),
    page: pages.OpForm,
  },
  {
    key: PAGES_KEYS.purchaseOrderDetails,
    path: PATHS.purchaseOrderDetails(),
    page: pages.PurchaseOrderDetails,
  },
  {
    key: PAGES_KEYS.receiveFormDetails,
    path: PATHS.receiveFormDetails(),
    page: pages.ReceiveFormDetails,
  },
  {
    key: PAGES_KEYS.requestPurchaseOrder,
    path: PATHS.requestPurchaseOrder,
    page: pages.RequestPurchaseOrder,
  },
  {
    key: PAGES_KEYS.transferOrder,
    path: PATHS.transferOrder(),
    page: pages.TransferOrderDetails,
  },
  {
    key: PAGES_KEYS.newTransferOrder,
    path: PATHS.newTransferOrder,
    page: pages.NewTransferOrder,
  },
  {
    key: PAGES_KEYS.mechanicDetailsPage,
    path: PATHS.mechanicDetailsPage(),
    page: pages.MechanicDetailsPage,
  },
  {
    key: PAGES_KEYS.newCar,
    path: PATHS.newCar,
    page: pages.CreateCar,
  },
  {
    key: PAGES_KEYS.editCar,
    path: PATHS.editCar(),
    page: pages.EditCar,
  },
  {
    key: PAGES_KEYS.createCarBrand,
    path: PATHS.createCarBrand,
    page: pages.CreateCarBrand,
  },
  {
    key: PAGES_KEYS.editCarBrand,
    path: PATHS.editCarBrand,
    page: pages.EditCarBrand,
  },
  {
    key: PAGES_KEYS.createCarModel,
    path: PATHS.createCarModel,
    page: pages.CreateCarModel,
  },
  {
    key: PAGES_KEYS.editCarModel,
    path: PATHS.editCarModel,
    page: pages.EditCarModel,
  },
  {
    key: PAGES_KEYS.createCarEngine,
    path: PATHS.createCarEngine,
    page: pages.CreateCarEngine,
  },
  {
    key: PAGES_KEYS.newSupplier,
    path: PATHS.newSupplier,
    page: pages.AddNewSupplier,
  },
  {
    key: PAGES_KEYS.editSupplier,
    path: PATHS.editSupplier(),
    page: pages.EditSupplier,
  },
  {
    key: PAGES_KEYS.supplierPricingDashboard,
    path: PATHS.supplierDashboard(),
    page: pages.SupplierShop,
  },
  {
    key: PAGES_KEYS.supplierDetailsPage,
    path: PATHS.supplierDetailsPage(),
    page: pages.SupplierDetailsPage,
  },
  {
    key: PAGES_KEYS.newSku,
    path: PATHS.newSku,
    page: pages.AddNewSku,
  },
  {
    key: PAGES_KEYS.editSku,
    path: PATHS.editSku(),
    page: pages.EditSku,
  },
  {
    key: PAGES_KEYS.replicateSku,
    path: PATHS.replicateSku(),
    page: pages.ReplicateSku,
  },
  {
    key: PAGES_KEYS.skuDetails,
    path: PATHS.skuDetails(),
    page: pages.SkuDetailsPage,
  },
  {
    key: PAGES_KEYS.PickingSkuModal,
    path: PATHS.PickingSkuModal(),
    page: pages.PickingSkuModal,
  },
  {
    key: PAGES_KEYS.pickingOrderModal,
    path: PATHS.pickingOrderModal(),
    page: pages.PickingOrderModal,
  },
  {
    key: PAGES_KEYS.newSkuName,
    path: PATHS.newSkuName,
    page: pages.CreateSkuName,
  },
  {
    key: PAGES_KEYS.newSkuBrand,
    path: PATHS.newSkuBrand,
    page: pages.CreateSkuBrand,
  },
  {
    key: PAGES_KEYS.editSkuBrand,
    path: PATHS.editSkuBrand,
    page: pages.EditSkuBrand,
  },
  {
    key: PAGES_KEYS.editSkuName,
    path: PATHS.editSkuName,
    page: pages.EditSkuName,
  },
  {
    key: PAGES_KEYS.newSkuCategory,
    path: PATHS.newSkuCategory,
    page: pages.CreateSkuCategory,
  },
  {
    key: PAGES_KEYS.editSkuCategory,
    path: PATHS.editSkuCategory,
    page: pages.EditSkuCategory,
  },
  {
    key: PAGES_KEYS.newSkuSubCategory,
    path: PATHS.newSkuSubCategory,
    page: pages.CreateSkuSubCategory,
  },
  {
    key: PAGES_KEYS.editSkuSubCategory,
    path: PATHS.editSkuSubCategory,
    page: pages.EditSkuSubCategory,
  },
  {
    key: PAGES_KEYS.createSkuOrigin,
    path: PATHS.newSkuOrigin,
    page: pages.CreateSkuOrigin,
  },
  {
    key: PAGES_KEYS.editSkuOrigin,
    path: PATHS.editSkuOrigin,
    page: pages.EditSkuOrigin,
  },
  {
    key: PAGES_KEYS.newSkuForSkuPending,
    path: PATHS.newSkuForSkuPending(),
    page: pages.AddNewSku,
  },
  {
    key: PAGES_KEYS.newSkuForSupplierSkuPending,
    path: PATHS.newSkuForSupplierSkuPending(),
    page: pages.AddNewSku,
  },
  {
    key: PAGES_KEYS.newBrandFamily,
    path: PATHS.newBrandFamily,
    page: pages.NewBrandFamily,
  },
  {
    key: PAGES_KEYS.editBrandFamily,
    path: PATHS.editBrandFamily(),
    page: pages.EditBrandFamily,
  },
  {
    key: PAGES_KEYS.newPromotion,
    path: PATHS.newPromotion,
    page: pages.CreatePromotion,
  },
  {
    key: PAGES_KEYS.newBundle,
    path: PATHS.newBundle,
    page: pages.CreateBundle,
  },
  {
    key: PAGES_KEYS.addRole,
    path: PATHS.addRole,
    page: pages.AddRole,
  },
  // {
  //   key: PAGES_KEYS.createScheduledNotification,
  //   path: PATHS.createScheduledNotification,
  //   page: pages.CreateScheduledNotification,
  // },
  {
    key: PAGES_KEYS.editRole,
    path: PATHS.editRole(),
    page: pages.EditRole,
  },
  {
    key: PAGES_KEYS.createCourier,
    path: PATHS.createCourier,
    page: pages.CreateCourier,
  },
  {
    key: PAGES_KEYS.editCourier,
    path: PATHS.editCourier(),
    page: pages.EditCourier,
  },
  {
    key: PAGES_KEYS.createSalesAgent,
    path: PATHS.createSalesAgent,
    page: pages.CreateSalesAgentPage,
  },
  {
    key: PAGES_KEYS.editSalesAgent,
    path: PATHS.editSalesAgent(),
    page: pages.EditSalesAgentPage,
  },
  {
    key: PAGES_KEYS.newStockReturnOrder,
    path: PATHS.newStockReturnOrder,
    page: pages.NewStockReturnOrderPage,
  },
  {
    key: PAGES_KEYS.editStockReturnOrder,
    path: PATHS.editStockReturn(),
    page: pages.EditStockReturnOrderPage,
  },
  {
    key: PAGES_KEYS.addPolygons,
    path: PATHS.addPolygons,
    page: pages.AddPolygons,
  },
  // {
  //   key: PAGES_KEYS.newBanner,
  //   path: PATHS.newBanner,
  //   page: pages.NewBanner,
  // },
  // {
  //   key: PAGES_KEYS.editBanner,
  //   path: PATHS.editBanner(),
  //   page: pages.EditBanner,
  // },
  {
    key: PAGES_KEYS.newReason,
    path: PATHS.newReason,
    page: pages.NewReason,
  },
  {
    key: PAGES_KEYS.editReason,
    path: PATHS.editReason(),
    page: pages.EditReason,
  },
  {
    key: PAGES_KEYS.createPicker,
    path: PATHS.createPicker,
    page: pages.CreatePicker,
  },
  {
    key: PAGES_KEYS.editPicker,
    path: PATHS.editPicker(),
    page: pages.EditPicker,
  },
  {
    key: PAGES_KEYS.updateMtorAiMapping,
    path: PATHS.updateMtorAiMapping,
    page: pages.UpdateMtorAiMapping,
  },
  {
    key: PAGES_KEYS.receiveConsignmentOrder,
    path: PATHS.receiveConsignmentOrder(),
    page: pages.ReceiveConsignmentOrder,
  },
  {
    key: PAGES_KEYS.viewConsignmentOrder,
    path: PATHS.viewConsignmentOrder(),
    page: pages.ViewConsignmentOrder,
  },
  {
    key: PAGES_KEYS.viewConsignmentReturnOrder,
    path: PATHS.viewConsignmentReturnOrder(),
    page: pages.ViewConsignmentReturnOrder,
  },
];

// all routes
export const ROUTES = [
  ...SIDE_DRAWER_ROUTES,
  ...getSideDrawerChildrenRoutes(SIDE_DRAWER_CHILDREN_ROUTES),
  ...SINGLE_PAGE_ROUTES,
];
